import React from 'react';
import { Link } from 'react-router';
import validator from 'validator';
import {
  isFullSiteMode,
  isMobileDevice,
  setResponsiveMode,
  setFullSiteMeta,
  setMobileMeta,
} from 'utils/fullSite';
import { signInFullSite as signInFullSiteClevertap } from 'clevertap/mWebFullSiteSwitch';
import { Trans, t } from '@lingui/macro';
import { I18n } from '@lingui/react';
import styles from './Login.css';

const isPhoneNumberValid = phoneNumber => {
  return (
    phoneNumber.length >= 10 &&
    phoneNumber.length <= 13 &&
    (phoneNumber.substr(0, 3) === '+62' || phoneNumber.substr(0, 1) === '0')
  );
};

const validate = loginId => {
  if (!loginId) {
    return t`The email address or phone number is required`;
  }
  if (isNaN(loginId) && !validator.isEmail(loginId)) {
    return t`Enter a valid email address`;
  }
  if (!isNaN(loginId) && !isPhoneNumberValid(loginId)) {
    return t`Enter a valid phone number`;
  }
  return '';
};

class LoginIdEntry extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showFullSiteSwitch: isMobileDevice() && !isFullSiteMode(),
      error: '',
    };
  }

  handleLoginIdChange = e => {
    const { onChange } = this.props;
    onChange(e.target.value);
  };

  handleSubmit = e => {
    e.preventDefault();

    this.setState(
      {
        error: '',
      },
      () => {
        const { onNext, loginId } = this.props;
        const error = validate(loginId);

        if (error) {
          this.setState({
            error,
          });
        } else {
          onNext();
        }
      }
    );
  };

  handleFullSiteSwitchClick = () => {
    if (!isFullSiteMode()) {
      setResponsiveMode(false);
    } else {
      setResponsiveMode(true);
    }

    // disable responsive
    if (isMobileDevice()) {
      setFullSiteMeta();
    } else {
      // enable responsive
      setMobileMeta();
    }

    signInFullSiteClevertap();

    this.setState({
      showFullSiteSwitch: false,
    });
  };

  render() {
    const { loginId, appName } = this.props;
    const { error, showFullSiteSwitch } = this.state;
    const isMobileMode = isMobileDevice() && !isFullSiteMode();

    return (
      <div className={styles.container}>
        <div className={styles.header}>
          {appName ? (
            <div className={styles.titleOpenPlatform}>
              <Trans>
                Sign in to use <strong>{appName}</strong>
              </Trans>
            </div>
          ) : (
            <div className={styles.title}>
              <Trans>Sign In</Trans>
            </div>
          )}
        </div>

        <form onSubmit={this.handleSubmit}>
          <div className="form-group">
            <I18n>
              {({ i18n }) => (
                <input
                  type="text"
                  name="email"
                  className="form-control"
                  placeholder={i18n._(t`Email or Phone Number`)}
                  autoCapitalize="off"
                  autoCorrect="off"
                  maxLength="255"
                  spellCheck="false"
                  value={loginId}
                  onChange={this.handleLoginIdChange}
                />
              )}
            </I18n>
            {error && (
              <small className="error">
                <Trans id={error} />
              </small>
            )}
          </div>

          <div className="form-group">
            <button type="submit" className="btn btn-primary btn-block">
              <Trans>Next</Trans>
            </button>
          </div>
        </form>

        <div className={styles.footer}>
          <Trans>
            Don't have a Moka account? <Link to="/register">Sign Up</Link>
          </Trans>
        </div>

        {isMobileMode && showFullSiteSwitch && (
          <div>
            <div className={styles.fullSiteOrRow}>
              <div className={styles.fullSiteOrLine} />
              <div className={styles.fullSiteOrText}>or</div>
              <div className={styles.fullSiteOrLine} />
            </div>
            <div
              className={styles.fullSiteLink}
              onClick={this.handleFullSiteSwitchClick}
            >
              <Trans>Sign In Full Site</Trans>
            </div>
          </div>
        )}
      </div>
    );
  }
}

LoginIdEntry.defaultProps = {
  onChange: () => {},
  onNext: () => {},
  loginId: '',
  appName: '',
};

export default LoginIdEntry;
